export default "__VITE_ASSET__DF_h9_Ev__"